import { toggleVideo } from "../../../../store/reducers/livestreamSettings";
import { IoVideocamOffOutline, IoVideocamOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import CLASSNAME from "./classname";
import SIZE from "./size";
import { RootState } from "../../../../store";
import RoomClient from "components/containers/utils/mediaSoup/RoomClient";
import { useEffect, useMemo, useState } from "react";
import { getCamState } from "utils/StreamingHelperFunctions";

interface VideoProps {
  roomClient: RoomClient | null;
}

const VideoControl = ({ roomClient }: VideoProps) => {
  const settings = useSelector((state: RootState) => state.live.settings);
  const dispatch = useDispatch();
  const producers = useSelector((state: RootState) => state.live.settings.producers);
  const [micState, setMicState] = useState<'on' | 'off' | 'unsupported'>('unsupported');
  const [webcamState, setWebcamState] = useState<'on' | 'off'>('off');
  const videoProducer: any = useMemo(() => {
    return Object.values(producers).find((p: any) => p.kind === "video");
  }, [producers]);

  const audioProducer: any = useMemo(() => {
    return Object.values(producers).find((p: any) => p.kind === "video");
  }, [producers]);

  const camState = useMemo(
    () => getCamState(videoProducer, settings.video, settings.isCameraAccessGranted),
    [videoProducer, settings.video, settings.isCameraAccessGranted]
  );

  // useEffect(() => {
  //   // Update micState
  //   if (!audioProducer) {
  //     setMicState('unsupported');
  //   } else if (!audioProducer.paused) {
  //     setMicState('on');
  //   } else {
  //     setMicState('off');
  //   }
  //   // Update webcamState
  //   if (videoProducer && videoProducer.type !== 'share') {
  //     setWebcamState('on');
  //   } else {
  //     setWebcamState('off');
  //   }
  // }, [audioProducer, videoProducer]);

  // const toggleWebCam = async () => {
  //   if (camState === 'on') {
  //     await roomClient?.disableWebcam();
  //     dispatch(toggleVideo(false));
  //   } else if (camState === 'off') {
  //     await roomClient?.enableWebcam();
  //     dispatch(toggleVideo(true));
  //   } else if (camState === 'unsupported') {
  //     await roomClient?.startProducing().then(() => roomClient?.enableWebcam());
  //     dispatch(toggleVideo(true));
  //   }
  // };

  const toggleWebCam = async () => {
    if (roomClient) {
      switch (camState) {
        case "on":
          roomClient?.disableWebcam();
          dispatch(toggleVideo(false));
          break;
        case "off":
          roomClient?.enableWebcam();
          dispatch(toggleVideo(true));
          break;
        case "unsupported":
          roomClient?.startProducing().then(() => roomClient?.enableWebcam());
          dispatch(toggleVideo(true));
          break;
        case "denied":
        default:
          roomClient?.disableWebcam();
          dispatch(toggleVideo(false));
      }
    }
  }

  return (
    <div className="relative group">
      <button onClick={toggleWebCam}
        className={`${CLASSNAME} ${!settings.video && "bg-red-600"} `}
      >
        {webcamState === 'on' || settings.video ? (
          <IoVideocamOutline />
        ) : (
          <IoVideocamOffOutline />
        )}
      </button>
      <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 max-w-full bg-black text-white text-sm rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Video
      </div>
    </div>
  );
};

export default VideoControl;
